import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography, Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import Input from "../Common/Components/InputField";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { useForm } from "react-hook-form";
import ActionButton from "../Common/Components/Button";
import { useTranslation } from "react-i18next";
import BubbleImg from "../assets/bubbles.svg";
import Loading from "../Common/Components/Loading";
import { ShowAlert } from "../Common/Components/Alert";
import service from "../apiSection/service";
import { login, verifyUser } from "../apiSection/apiUrlConstent";
import { useDispatch } from "react-redux";
import { loginauth } from "../Common/ReduxStore/UserStore";
import { addCookies } from "../apiSection/util";
import { debounce } from "lodash";
import SetPassword from "./SetPassword";
import { useSelector } from "react-redux";

export default function LoginScreen(props) {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("common");
  const [loginData, setLoginData] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [tempUserData, setTempUserData] = useState(null);
  const token=useSelector((store)=>store.auth.token);
  const {
    register,
    handleSubmit : reactHookFormHandleSubmit,

    setError,
    clearErrors,
    formState: { errors },
  } = useForm();
  const hanldeshowPassword = (data) => {
    setShowPassword(data);
  };
  const handleLogin = (data) => {
    setLoading(true);
    let postData = {
      user_login: data.receiveremailaddress,
      password: data.password,
    };
    service
      .create(login, postData)
      .then((res) => {
        if (i18n && i18n.changeLanguage) {
          const stateId = res.data?.result?.state_id;

          switch (stateId) {
            case 1:
              i18n
                .changeLanguage("guj")
                .catch((err) =>
                  console.error("Error switching to Gujarati:", err)
                );
              break;
            case 2:
              i18n
                .changeLanguage("tam")
                .catch((err) =>
                  console.error("Error switching to Tamil:", err)
                );
              break;
            case 3:
              i18n
                .changeLanguage("tri")
                .catch((err) =>
                  console.error("Error switching to Tripura:", err)
                );
              break;
              case 4:
              i18n
                .changeLanguage("miz")
                .catch((err) =>
                  console.error("Error switching to Mizoram:", err)
                );
              break;
            default:
              i18n
                .changeLanguage("en")
                .catch((err) =>
                  console.error("Error switching to English:", err)
                );
              break;
          }
        }

        setLoading(false);
        
        if (res.data.result.is_password_updated === 0) {
          setTempUserData(res.data.result)
          setShowNewPassword(true);
        } else {
          dispatch(loginauth(res.data.result));
          localStorage.setItem("userId", res.data.result.role_id);
          addCookies(res.data.result.token);
          props.Redirectpath("/dashboard");
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.data) {
          if (error.response.data.message == "Invalid credential's") {
            setLoading(false);
            ShowAlert({
              icon: "error",
              text: error.response.data.message,
              width: "400px",
            });
          } else {
            setLoading(false);
            ShowAlert({
              icon: "error",
              text: error.response.data.message,
              width: "400px",
            });
          }
        } else {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: "Something went wrong",
            width: "400px",
          });
        }
      });
  };

  const handleVerifyUser = (data) => {
    setLoading(true);
    const postData = {
      user_login: data.receiveremailaddress,
    };

    service
      .create(verifyUser, postData)
      .then((res) => {
        setLoading(false);
        if (res && res.message) {
          setError("receiveremailaddress", {
            type: "verify",
            message: res.message,
          });
        } else {
          clearErrors("receiveremailaddress");
        }
      })
      .catch((error) => {
        setLoading(false);
        setError("receiveremailaddress", {
          type: "verify",
          // message: "User does not exist",
          message: error.response.data.message,
        });
      });
  };
  const debouncedHandleVerifyUser = useCallback(
    debounce(handleVerifyUser, 3000),
    []
  );

  const handleForgetPasswordRedirect = () => {
    props.Redirectpath("/ForgotPassword");
  };
  
  const handleKeyPressPassword = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      reactHookFormHandleSubmit(handleLogin)();
    }
  };

  

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Loading open={loading} />
      {/* Left Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #0FA5D9 100%);",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
        }}
      >
        <Box textAlign="center">
          <div>
            <img src={BubbleImg} width="100%" />
          </div>
          <Typography
            color="#FFFFFF"
            sx={{
              fontStyle: "italic",
              fontFamily: "Poppins",
              fontSize: "40px",
            }}
          >
            AI-POWERED
          </Typography>
          <Typography
            color="#000080"
            sx={{
              mt: 2,
              fontStyle: "italic",
              fontFamily: "Poppins",
              fontSize: "36px",
            }}
          >
            Help Desk
          </Typography>
        </Box>
      </Grid>

      {/* Right Section */}
      {(showNewPassword && tempUserData && tempUserData.token )? (
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            bgcolor: "#fff",
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 400 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#3399FF" }}
            >
              Ticketing Tool
            </Typography>
            <Typography color="#4B5563" sx={{ mt: 1 }}>
              Please Update your Password to log in to the application.
            </Typography>

            {/* Form */}
            <Box component="form" noValidate sx={{ mt: 4 }}>
              <SetPassword Redirectpath={props.Redirectpath} userData={tempUserData} loaded_from="LOGIN" />
            </Box>
          </Box>
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            bgcolor: "#fff",
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 400 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#3399FF" }}
            >
              Ticketing Tool
            </Typography>
            <Typography color="#4B5563" sx={{ mt: 1 }}>
              Please enter your credentials to log in to the application.
            </Typography>

            {/* Form */}
            <Box component="form"  sx={{ mt: 4 }}>
              <div style={{ padding: "10px 0px" }}>
                <Input
                  name="receiveremailaddress"
                  type="text"
                  id="receiveremailaddress"
                  label="PAC’S ID / Email Address / Mobile Number"
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  placeholder="PAC’S ID / Email Address / Mobile Number"
                  required={true}
                  handleKeyPress={handleKeyPressPassword}
                  inputRef={register("receiveremailaddress", {
                    required: true,
                    onChange: (e) => {
                      debouncedHandleVerifyUser({
                        receiveremailaddress: e.target.value,
                      });
                    },
                    // pattern: {
                    //   value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    //   message: "Invalid email address",
                    // },
                  })}
                />
                <div>
                  {errors.receiveremailaddress &&
                    errors.receiveremailaddress.type === "required" && (
                      <ErrorMessage message="Email is Required !!" />
                    )}
                  {errors.receiveremailaddress && (
                    <ErrorMessage
                      message={errors.receiveremailaddress.message}
                    />
                  )}
                </div>
              </div>
              <div style={{ padding: "10px 0px" }}>
                <Input
                  name="password"
                  label="Password"
                  id="password"
                  borderRadius="8px"
                  placeholder="***********"
                  border="none"
                  type={showPassword ? "text" : "password"}
                  visibilityIcon
                  required={true}
                  backgroundColor="#000024"
                  hanldeshowPassword={hanldeshowPassword}
                  visibilityIconColor="#0FA5D8"
                  visibilityIconFont="17px"
                  handleKeyPress={handleKeyPressPassword}
                  inputRef={register("password", {
                    required: true,
                  })}
                />
              </div>
              <div>
                {errors.password && errors.password.type === "required" && (
                  <ErrorMessage message="Required !!" />
                )}
              </div>
              <div>
                {errors.password && (
                  <ErrorMessage message={errors.password.message} />
                )}
              </div>
              <Link
                sx={{
                  display: "block",
                  mt: 1,
                  color: "#2B3674",
                  cursor: "pointer",
                }}
                onClick={handleForgetPasswordRedirect}
              >
                Forgot Password
              </Link>

              <div style={{ padding: "15px 0px" }}>
                <ActionButton
                  backgroundColor="#3399FF"
                  color="white"
                  fullWidth={true}
                  buttonText="Login"
                  handleSubmit={reactHookFormHandleSubmit(handleLogin)}
                />
              </div>
            </Box>

            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              sx={{ mt: 4 }}
            >
              ©2024 Powered by Machint Solutions Ltd <a href="https://www.machint.com/privacy-policy.html" target="_blank">Privacy Policy</a>
              
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
}
